import { array, object, string } from 'valibot';

export const choicesScheme = object({
	choices: array(array(string())),
});
